const initLuckyOrange = () => {
  window.LOQ = window.LOQ || []
  window.LOQ.push(['ready', LO => {
    const body = document.body;
    if(body.hasAttribute('data-account-id')){
      let config = {};

      if(body.hasAttribute('data-firstname')){
        config.firstname = body.dataset.firstname;
      }
      if(body.hasAttribute('data-lastname')){
        config.lastname = body.dataset.lastname;
      }

      config.mail = body.dataset.mail;
      config.isHost = body.dataset.isHost === 'true';
      config.bookingsPurchased = body.dataset.bookingsPurchased;
      config.gcPurchased = body.dataset.gcPurchased;

      LO.visitor.identify(body.dataset.accountId, config);
    }
  }]);
}

export { initLuckyOrange }

